import { createFileRoute } from "@tanstack/react-router";

import { prefetchForProject } from "../../lib/prefetch";
import { useProjectId } from "../../shell/project";
import { OrdersPage } from "../../workspaces/projects/pages/OrdersPage";

export const Route = createFileRoute("/_console/p/$org/$project/orders/")({
  loader: ({ context: { queryClient }, params }) =>
    prefetchForProject(
      queryClient,
      params,
      import("../../workspaces/supply/orders"),
      ({ projectShipmentQueries }, projectId) => {
        const reads = projectShipmentQueries(projectId);
        return Promise.all([
          queryClient.prefetchQuery(reads.shipments),
          queryClient.prefetchQuery(reads.dataKinds),
        ]);
      },
    ),
  component: ProjectOrdersRoute,
});

/** The Orders workspace's own address: this project's Orders, as its customer sees them. */
function ProjectOrdersRoute() {
  return <OrdersPage projectId={useProjectId()} />;
}
